import React, { PropsWithChildren, useContext } from "react";

import { Fade } from "../animations/fade";
import { TabsContext } from "./tabs-context";

export interface TabPanelProps {
  id: string;
  className?: string;
}

export function TabPanel({ id, children, className }: PropsWithChildren<TabPanelProps>) {
  const { activeTab } = useContext(TabsContext);
  const isActive = activeTab === id;

  return (
    <Fade className={className} visible={isActive} mode="popLayout">
      {children}
    </Fade>
  );
}
